// Resolve the API origin from the page's current hostname.
//
//   localhost:5174           -> http://localhost:7112       (dev backend on the Functions host)
//   www.pag-asenso.com       -> https://api.pag-asenso.com  (production: API sits at the apex's api subdomain)
//   pag-asenso.com           -> https://api.pag-asenso.com
//   salmon-glacier-*.azurestaticapps.net (or any other SWA-default hostname)
//                            -> https://pagasenso-backend.azurewebsites.net
//                               (a hard fallback so the bare SWA URL still works
//                                before the custom domain is wired up)
//
// CORS is configured on the Function App for the production frontend
// origins; auth uses the Authorization bearer header which is a
// non-simple CORS header, so the preflight is exercised. No cookies
// are sent cross-origin (header auth only).
function resolveDefaultDomain(): string {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
    return 'http://localhost:7112';
  }
  // Strip a leading "www." so the api subdomain lives at the apex, not
  // at api.www.X.com. Apex-served PWAs already match.
  const apex = host.replace(/^www\./i, '');
  if (apex === 'pag-asenso.com') {
    return 'https://api.pag-asenso.com';
  }
  // Pre-custom-domain access (SWA default *.azurestaticapps.net hostname
  // or a preview environment). Hit the Function App directly.
  return 'https://pagasenso-backend.azurewebsites.net';
}

export const defaultDomain = resolveDefaultDomain();
